<template>
  <div class="c-survey__popup-modal">
    <div class="c-survey__popup-modal-content">
      <h1>{{ heading }}</h1>
      <main v-html="message" class="c-survey__html"></main>
      <div class="c-survey__actionbutton-row">
        <a href="#" @click.prevent="$emit('close')" target="_self" class="readmore readmore__linkBox readmore__linkBox--muted readmore__linkBox--arrow-left">
          <p>Cancel</p>
          <span></span>
        </a>
        <a href="#" @click.prevent="$emit('confirm')" target="_self" class="readmore readmore__linkBox">
          <p>Confirm</p>
          <span></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    heading: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
  },
};
</script>
